module.exports = __webpack_public_path__ + "static/img/3.d7dd9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1/3.png
// module id = Q2Pc
// module chunks = 1